import { useState } from "react";

const Profile = () => {
  const [token] = useState("");
  const [message, setMessage] = useState("");

  const handleProfile = async () => {
    const response = await fetch("http://localhost:5000/profile", {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    setMessage(data.message);
  };

  return (
    <>
      <div>
        <h2>Profile</h2>
        <button onClick={handleProfile} disabled={!token}>
          Get Profile
        </button>
        {message && <p>{message}</p>}
      </div>
    </>
  );
};

export default Profile;
